import { Component, EventEmitter, Input, OnInit, Output,SimpleChanges,ChangeDetectorRef } from '@angular/core'
import { Stringable, StringableValues } from '../../../../../../common/stringable.decorator'

import { JSONRpcResponse } from '../../../../../../Interfaces/JSONRpcResponse'
import { ConsultationService,DialogService, StateService, VisiteService} from '../../../../../../services'
import { CreateConsultationDialogComponent } from '../../../actions/create-consultation-dialog/create-consultation-dialog.component'
import { VisiteActionsDialog } from '../../../actions/visite-actions-dialog/visite-actions-dialog.component'

import { ContextMenu } from "../../../../layout/context-menu/icontextmenu.component"

const KEY = 'consultation-calendar-day'

@Component({
	selector: 'atyl-day',
	templateUrl: './day.component.html',
	styleUrls: ['./day.component.scss'],
})

@Stringable({
	path: 'views/pages/consultation/calendar/day/day',
	key: KEY,
})
export class DayComponent implements OnInit {
	@Input() consultationListDay: any = {};
	@Input() currentConsultation: any = null;
	@Output() consultationClicked = new EventEmitter<any>();
	@StringableValues(KEY) strings: any
	@Input() isvisite: boolean = false;
	isvisite2: boolean = true;
	constructor(private changeDetectorRef: ChangeDetectorRef,
			private dialogService: DialogService,
			private consultationService: ConsultationService,
		      private stateService: StateService,
			private visiteService: VisiteService,
	) { }

	hours:any=[];
	
    beginHour:number=800
    beginEnd:number=2000;
    priodTranch:number=10;
    priodAjustTranch:number=40;
    @Input()  periods:any;


    myconsultation:any;
   
	isDisplayContextMenu: boolean;
	rightClickMenuItems: Array<ContextMenu> = [];
	rightClickMenuPositionX: number;
	rightClickMenuPositionY: number;
	rightClickStyle: any={};
	
	ngOnInit() {
	//	console.log("DayComponent day",this.consultationListDay,this.isvisite);
		if (this.periods==undefined)
			this.getInitLabelPeriod();
	}
	
	ngOnChanges(changes: SimpleChanges) {
        
      //console.log("day change",this.consultationListDay);
        
    }
	

	oneConsultationClicked(event: any, consultationDay: any) {
		this.consultationClicked.emit(event)
	}
	isSelected(event: any) {
		if ((this.currentConsultation != null) && this.currentConsultation.ID === event.ID) {
			return true
		}
		return false
	}
	
	
	displayDay() {
        let css:any=[];
        let l=this.consultationListDay.consultation.length;
        
        let col:number=0;
        switch (l) {
	       case 1:
	       case 2:
	          col=5;break;
	       case 3:
	          col=3;break;   
	       case 4:
	       case 5:
	          col=2;break; 
	       default:
	           col=1;break;     
		}
		css.push("col-"+col)
        css.push("oneday");
        
        return css.join(" ")
    }
    
    displayColumns() {
        let css:any=[];
        let l=this.consultationListDay.consultation.length;
        
        let col:number=0;
        switch (l) {
	       case 1: 
	       case 2:
	          col=6;break;
	       case 3:
	          col=3;break;   
	       case 4:
	       case 5:
	       case 6:
	          col=2;break; 
	       default:
	           col=1;break;     
		}
		return col;
    }
    
    displayDayList(lst:any[],index:number) {
        let css:any=[];
        let l=lst.length;
//        console.log("displayDayList",lst,l)
        let col:number=10;
        switch (l) {
            
            case 1:
                lst[index].width = "13";
                //lst[index].move = "";
               break;
            case 2:
                if(index == 0){
                    lst[index].width = "12";
                    lst[index].move =  "0"
                }else{
                    lst[index].width = "11";
                    lst[index].move =  "4"
                }
                col=2;
               break;
            case 3:
                if(index == 0){
                    lst[index].width = "9";
                    lst[index].move =  "0"
                 
                }else if(index == 1){
                    lst[index].width = "10";
                    lst[index].move =  "3"
             
                }else{
                    lst[index].width = "9";
                    lst[index].move =  "4"
                }
                col=2;
	            break;     
            case 4:
                if(index == 0){
                    lst[index].width = "9";
                    lst[index].move =  "0"
                }else if(index == 1){
                    lst[index].width = "8";
                    lst[index].move =  "0"
                }else if(index == 2){
                    lst[index].width = "7";
                    lst[index].move =  "0"
                }else{
                    lst[index].width = "6";
                    lst[index].move =  "4"
                }
                col=2;
            case 5:
                if(index == 0){
                    lst[index].width = "9";
                    lst[index].move =  "0"
                }else if(index == 1){
                    lst[index].width = "8";
                    lst[index].move =  "0"
                }else if(index == 2){
                    lst[index].width = "7";
                    lst[index].move =  "0"
                }else if(index == 3){
                    lst[index].width = "6";
                    lst[index].move =  "0"
                }else{
                    lst[index].width = "6";
                    lst[index].move =  "4"
                }
                col=2;
               break; 
            default:
                if(index == 0){
                    lst[index].width = "9";
                    lst[index].move =  "0"
                }else if(index == 1){
                    lst[index].width = "8";
                    lst[index].move =  "0"
                }else if(index == 2){
                    lst[index].width = "7";
                    lst[index].move =  "0"
                }else if(index == 3){
                    lst[index].width = "6";
                    lst[index].move =  "0"
                }else if(index == 4){
                    lst[index].width = "6";
                    lst[index].move =  "0"
                }else if(index == 5){
                    lst[index].width = "6";
                    lst[index].move =  "0"
                }else{
                    lst[index].width = "9";
                    lst[index].move =  "4"
                }
                col=2;
                break; 
         }
         css.push("col-"+col);
         
         return css.join(" ");
    }
    
	getInitLabelPeriod() {
			this.periods=[];
			let count=0;
			let tolalM:number=720;
			while(this.beginHour<=this.beginEnd) {
				let hm =('0' + this.beginHour).slice(-4);

	            let vingtieme = this.beginHour % 20 ? '-' :'- '+parseInt(hm.substring(2,4))
				
			    
				let min:number=this.getTimeMinute(hm)-8*60;
				let max:number=8*60+tolalM-(this.getTimeMinute(hm)+10);
								
				let top:number=min*100/tolalM;
				let bottom:number=max*100/tolalM;
							
				let hmo={
					inset: {
						"top": top,
						"bottom": bottom,
						"left":0,
						"right" :0
					},
					period: hm,
					label: ((this.beginHour % 100)==0) ? this.getTimeLabel(hm) : vingtieme,
					
					
				};
				//console.log('getInitLabelPeriod hmo.label:',hmo.label,'\ntaille hmo.label:',(hmo.label).length);
	            
				this.periods.push(hmo);
				this.beginHour+= this.priodTranch;
				count++;
				if (count==6) {
					count=0;
					this.beginHour+=this.priodAjustTranch;
				}
			
			
				/*console.log("periods defaults",
					this.periods);*/
			
			}
	}
		
	getTimeMinute(hm:string) {
				let h:string=hm.substr(0,2);
				let m:string=hm.substr(2);
				let min:number=parseInt(h)*60+parseInt(m);
				return min;
		}
		
	getStylePeriod(period:any) {
			
			
			let st:string=period.inset.top + "% "+period.inset.right+"% "+ period.inset.bottom+"% "+ period.inset.left +"%";
			
			let style:any={
				inset:st									
													    
											
			}		
				
			return style;	
	}
	
	getTimeLabel(hm:string) {
		let h:string=hm.substr(0,2);
		let m:string=hm.substr(2);
		return h + ":" + m;
	}
	
	getConsultListInPeriod(periods:any) {
		let clt:any[]=[];
		for(let i=0;i<this.consultationListDay.consultation.length;i++) {
			 if (this.consultationListDay.consultation[i].periodes.includes(periods.period)) 
			     clt.push(this.consultationListDay.consultation[i]);
		}
		return clt;
	}
	
	getStyleConsultation(consultation:any) {
		let isconsult:boolean=(!consultation.consultation);
		let color:any= consultation.consultation 
				?consultation.consultation.type.color: consultation.type.color;
				
		let opacity:number= consultation.consultation ?
		consultation.consultation.type.alpha
			:consultation.type.alpha;
		if (!isconsult)
			opacity-=opacity*25/100;
		opacity/=255;	
		let style:any={
				position:"absolute",
				background:color,
				opacity:opacity
		};     
		
		console.log("getStyleConsultation",consultation,style);
		
		
      
		
	    if (consultation.inset!==undefined) {
			
			let inset:any=consultation.inset;
			let left:number=inset.left;
			if (left==0)
				left=left*(1+5/100);
			else
				left=left*(1+1/100);
			let st:string=inset.top+"% "+inset.right+"% "+ inset.bottom+"% "+left+"%";
			style.inset=st;
		}
		console.log("getStyleConsultation",consultation,style);
		return style;
	}
	
	onHoverElement(event:any,consultation:any) {
		console.log('onHoverElement',event,consultation);
		this.myconsultation=consultation;
		this.changeDetectorRef.detectChanges();
	}
	
	displayContextMenu(event:any,day:any,period:any) {

	  	   this.isDisplayContextMenu = !this.isDisplayContextMenu;
	       
	  			this.rightClickMenuItems = [
	  			     {
	  			       menuText: '<i class="la la-plus"></i> Séance',
	  			       menuEvent: 	 { action:'seance',
	  				   			       day:day,
									   period:period,
	  				   				},
	  			     },
	  				 {
	  				 		menuText: '<i class="la la-plus"></i> Rendez-vous',
	  				 		menuEvent: 	{ action:'visite',
											day:day,
											period:period,
							},
	  				  }
	  			]; 
	  		
	  	   	//this.rightClickMenuPositionX = event.clientX - event.offsetX;
	  	   //	this.rightClickMenuPositionY = event.clientY - event.offsetY;
		  // this.rightClickMenuPositionX = event.pageX;
		 //  this.rightClickMenuPositionY = event.pageY;
		// this.rightClickMenuPositionX = event.pageX-event.clientX
		 //	  this.rightClickMenuPositionY = event.pageY-event.clientY;
		 this.rightClickMenuPositionX =event.pageX-event.clientX;
		 this.rightClickMenuPositionY =event.pageY-event.clientY;
		  this.rightClickStyle=	 period;
			 
	         console.log("displayContextMenu",event,day,period);
	  	 }

	  	 getRightClickMenuStyle() {
			let style:any=this.getStylePeriod(this.rightClickStyle);
			style["position"]="absolute";
			
	  	   return style;
			/*return {
	  	     position: 'fixed',
	  	     left: `${this.rightClickMenuPositionX}px`,
	  	     top: `${this.rightClickMenuPositionY}px`
	  		 
	  			//margin: "5%
	  			//display: "block"
	  	   }*/
	  	 }

	  	 handleMenuItemClick(event) {
	  		//	event.event.preventDefault();
	  	     console.log("displayContextMenu Click",event);
			 
			 let menuEvent:any=event.data
			 this.isDisplayContextMenu = !this.isDisplayContextMenu;
		 this.createFormByPeriod(menuEvent.period.period,menuEvent.day,menuEvent.action)
	  		
	 	}
		
		createFormByPeriod(period: any, date: any, type: any){
		        var per = period[0]+period[1]+":"+period[2]+period[3];
		        var format = (f: any) =>{
		            let rpl = date.replaceAll("/","-");
		            let jour = rpl[0]+rpl[1]; 
		            let mois = rpl[3]+rpl[4]; 
		            let annee = rpl[6]+rpl[7]+rpl[8]+rpl[9];
		            let formater = annee+"-"+mois+"-"+jour;
		            return formater
		        }
		    
		        if(type == 'seance'){
		            this.consultationService.getConsultationTypeList().subscribe((res: JSONRpcResponse) => {
		            let dataCs={
		                action: "create",
		                dataType: "consultation",
		                code: type,
		                page:"consultation",
		                dateF: format(date),
		                startTimeInput: per,
		                dossier: undefined,
		                title: "Création d'une séance",
		                create: true,
		                types:res.result
		            }
		            console.log("createFormByPeriod",type,dataCs);
		            this.dialogService.open(CreateConsultationDialogComponent, {
		                data: dataCs,
		                height: "95vh",
		                width: "80vw",
		                draggable: true,
		                maximizable: true,
		                minimizable: true,
		                resizable: true,
		            }, () => {
		                let _refresh={
		                    type: "consultation",
		                    data:dataCs
		                };
		                console.log("consultationListe",0)
		                this.stateService.updateRefresh(_refresh)
		                this.consultationService
		                .consultationListe()
		                .subscribe((cons: JSONRpcResponse) => {
		                    console.log("consult:",cons);
		                    this.changeDetectorRef.detectChanges();
		                })
		                this.changeDetectorRef.detectChanges();
		            })
		        })
		        }else if(type == 'visite'){
		            let dataVs={
		                action: "create",
		                dataType: "rdv",
		                dateF: format(date),
		                startTimeInput: per,
		                code: "CREATE_VISITE",
		                page:"consultation",
		                dossier: undefined,
		                title: "Création d'un rendez-vous",
		                create: true,
		            }
					console.log("createFormByPeriod",type,dataVs);
					          
		            this.dialogService.open(VisiteActionsDialog, {
		                data: dataVs,
		                height: "95vh",
		                width: "80vw",
		                draggable: true,
		                maximizable: true,
		                minimizable: true,
		                resizable: true,
		            }, (res) => {
		                    console.log(res)
		                
		                    let _refresh={
		                        type: "visite",
		                        data:res
		                    };
		                    
		                    this.stateService.updateRefresh(_refresh)
		                
		                   
		                    this.visiteService
		                .list() 
		                .subscribe((res: JSONRpcResponse) => {
		                    console.log("view viste",res.result);
		                })
		                this.changeDetectorRef.detectChanges();
		            })
		        }
		    }
	 
}
